<div class="min-h-screen bg-gray-50">
  <div class="flex h-screen bg-gray-50">
    <app-sidebar></app-sidebar>
    <div class="font flex-1 flex flex-col overflow-hidden lg:ml-0">
      <header class="bg-white shadow-sm border-b border-gray-200 p-4 lg:px-6">
        <div class="flex items-center justify-between">
          <button class="lg:hidden text-gray-500 hover:text-gray-700" (click)="toggleMobileMenu()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-menu w-6 h-6">
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
          </button>
          <div class="flex-1 lg:flex lg:items-center lg:justify-between">
            <h6 class="text-lg font-semibold text-gray-900 ml-4 lg:ml-0">{{'SIDEBAR.SCREENING' | translate}}</h6>
          </div>
        </div>
      </header>
      <main class="font flex-1 overflow-auto p-4 lg:p-6">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
          <div>
            <h1 class="text-2xl font-bold text-gray-900">{{'CANDIDATES.SCREENING_BOARD' | translate}}</h1>
            <p class="mt-1 text-gray-600">{{'CANDIDATES.DRAG_DROP_CANDIDATES_BETWEEN_HIRING_STAGES' | translate}}</p>
          </div>
        </div>
        <div class="overflow-x-auto">
          <div class="flex space-x-6" style="min-width: 1200px;">

            <!-- Applied Column -->
            <div class="flex-1 min-w-[200px]">
              <div class="bg-gray-50 rounded-xl p-4 min-h-[600px] transition-all duration-200"
                [class.!border-2]="isDragOverMap['applied']" [class.!border-blue-300]="isDragOverMap['applied']"
                [class.!border-dashed]="isDragOverMap['applied']">
                <div class="flex items-center justify-between mb-4">
                  <h3 class="font-semibold text-gray-900">{{'CANDIDATES.APPLIED' | translate}}</h3>
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">{{columnTotalCount['applied']}}</span>
                </div>

                <div class="h-[500px] overflow-y-auto" [class.overflow-y-auto]="applied.length > 0"
                  [class.overflow-y-hidden]="applied.length === 0" (scroll)="onColumnScroll($event, 'applied')">
                  <div cdkDropList id="applied" [cdkDropListData]="applied"
                    [cdkDropListConnectedTo]="['screening', 'interview', 'reference', 'backgroundCheck', 'hired']"
                    (cdkDropListDropped)="drop($event)" (cdkDropListEntered)="onDragEntered('applied')"
                    (cdkDropListExited)="onDragExited('applied')" class="space-y-3 min-h-full">
                    <div *ngFor="let candidate of applied; trackBy: trackByFn" cdkDrag [cdkDragData]="candidate"
                      (cdkDragStarted)="onDragStarted(candidate.id)" (cdkDragEnded)="onDragEnded()"
                      [class.opacity-50]="draggingCandidateId === candidate.id"
                      class="bg-white p-4 rounded-lg shadow-sm border border-gray-200 cursor-move hover:shadow-md transition-shadow">
                      <div class="flex items-center mb-3">
                        <div class="w-10 h-10 rounded-full flex items-center justify-center overflow-hidden">
                          <ng-container *ngIf="candidate?.profilePicture?.url; else initials">
                            <img [src]="candidate?.profilePicture?.url" alt="{{ candidate.firstName }}" class="w-full h-full object-cover">
                          </ng-container>

                          <ng-template #initials>
                            <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                              <span class="text-blue-600 font-semibold">
                                {{ candidate.firstName?.charAt(0) }}
                              </span>
                            </div>
                          </ng-template>
                        </div>

                        <div class="ml-3">
                          <h4 class="font-semibold text-gray-900 text-sm">{{candidate.firstName}}
                            {{candidate.lastName}}</h4>
                        </div>
                      </div>
                      <div class="space-y-2 text-xs text-gray-500">
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-mail w-3 h-3 mr-2">
                            <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                            <path d="m22 7-10 5L2 7"></path>
                          </svg>
                          <span class="truncate">{{candidate.emailAddress}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-phone w-3 h-3 mr-2">
                            <path
                              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                            </path>
                          </svg>
                          <span>{{candidate.phoneNumber}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-calendar w-3 h-3 mr-2">
                            <path d="M8 2v4"></path>
                            <path d="M16 2v4"></path>
                            <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                            <path d="M3 10h18"></path>
                          </svg>
                          <span>{{'CANDIDATES.APPLIED' | translate}} {{candidate.created | date: 'MM/dd/yyyy'}}</span>
                        </div>
                      </div>
                      <div class="mt-3">
                        <div class="flex items-center justify-between mt-2">
                          <div class="flex flex-wrap gap-1">
                            <span 
                              *ngFor="let skill of getCandidateSkills(candidate)"
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                              {{skill}}
                            </span>
                          </div>
                          <div *ngIf="candidate.applicationVideo" class="flex items-center text-blue-600"
                            title="has video application">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-video w-3 h-3">
                              <path d="m22 8-6 4 6 4V8Z"></path>
                              <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-play w-2 h-2 ml-0.5">
                              <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="columnLoading['applied']" class="flex justify-center py-4">
                      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                    </div>
                    <div *ngIf="!columnHasMore['applied'] && applied.length > 0" class="text-center py-4">
                      <p class="text-sm text-gray-500">{{'CANDIDATES.NO_MORE_CANDIDATES' | translate}}</p>
                    </div>
                    <div *ngIf="shouldShowPlaceholder('applied')"
                      class="flex items-center justify-center h-32 text-gray-400">
                      <p class="text-sm">{{'CANDIDATES.DROP_CANDIDATES_HERE' | translate}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Screening Column -->
            <div class="flex-1 min-w-[200px]">
              <div class="bg-gray-50 rounded-xl p-4 min-h-[600px] transition-all duration-200"
                [class.!border-2]="isDragOverMap['screening']" [class.!border-blue-300]="isDragOverMap['screening']"
                [class.!border-dashed]="isDragOverMap['screening']">
                <div class="flex items-center justify-between mb-4">
                  <h3 class="font-semibold text-gray-900">{{'SIDEBAR.SCREENING' | translate}}</h3>
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">{{columnTotalCount['screening']}}</span>
                </div>
                <div class="h-[500px] overflow-y-auto" [class.overflow-y-auto]="screening.length > 0"
                  [class.overflow-y-hidden]="screening.length === 0" (scroll)="onColumnScroll($event, 'screening')">
                  <div cdkDropList id="screening" [cdkDropListData]="screening"
                    [cdkDropListConnectedTo]="['applied', 'interview', 'reference', 'backgroundCheck', 'hired']"
                    (cdkDropListDropped)="drop($event)" (cdkDropListEntered)="onDragEntered('screening')"
                    (cdkDropListExited)="onDragExited('screening')" class="space-y-3 min-h-[500px]">
                    <div *ngFor="let candidate of screening; trackBy: trackByFn" cdkDrag [cdkDragData]="candidate"
                      (cdkDragStarted)="onDragStarted(candidate.id)" (cdkDragEnded)="onDragEnded()"
                      [class.opacity-50]="draggingCandidateId === candidate.id"
                      class="bg-white p-4 rounded-lg shadow-sm border border-gray-200 cursor-move hover:shadow-md transition-shadow">
                      <div class="flex items-center mb-3">
                        <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                          <span class="text-blue-600 font-semibold">{{candidate.firstName.charAt(0)}}</span>
                        </div>
                        <div class="ml-3">
                          <h4 class="font-semibold text-gray-900 text-sm">{{candidate.firstName}} {{candidate.lastName}}</h4>
                        </div>
                      </div>
                      <div class="space-y-2 text-xs text-gray-500">
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-mail w-3 h-3 mr-2">
                            <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                            <path d="m22 7-10 5L2 7"></path>
                          </svg>
                          <span class="truncate">{{candidate.emailAddress}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-phone w-3 h-3 mr-2">
                            <path
                              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                            </path>
                          </svg>
                          <span>{{candidate.phoneNumber}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-calendar w-3 h-3 mr-2">
                            <path d="M8 2v4"></path>
                            <path d="M16 2v4"></path>
                            <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                            <path d="M3 10h18"></path>
                          </svg>
                          <span>{{'CANDIDATES.APPLIED' | translate}} {{candidate.created | date: 'MM/dd/yyyy'}}</span>
                        </div>
                      </div>
                      <div class="mt-3">
                        <div class="flex items-center justify-between mt-2">
                          <div class="flex flex-wrap gap-1">
                            <span 
                              *ngFor="let skill of getCandidateSkills(candidate)"
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                              {{skill}}
                            </span>
                          </div>
                          <div *ngIf="candidate.applicationVideo" class="flex items-center text-blue-600"
                            title="has video application">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-video w-3 h-3">
                              <path d="m22 8-6 4 6 4V8Z"></path>
                              <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-play w-2 h-2 ml-0.5">
                              <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="columnLoading['screening']" class="flex justify-center py-4">
                      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                    </div>
                    <div *ngIf="!columnHasMore['screening'] && screening.length > 0" class="text-center py-4">
                      <p class="text-sm text-gray-500">{{'CANDIDATES.NO_MORE_CANDIDATES' | translate}}</p>
                    </div>
                    <div *ngIf="shouldShowPlaceholder('screening')"
                      class="flex items-center justify-center h-32 text-gray-400">
                      <p class="text-sm">{{'CANDIDATES.DROP_CANDIDATES_HERE' | translate}}</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- Interview Column -->
            <div class="flex-1 min-w-[200px]">
              <div class="bg-gray-50 rounded-xl p-4 min-h-[600px] transition-all duration-200"
                [class.!border-2]="isDragOverMap['interview']" [class.!border-blue-300]="isDragOverMap['interview']"
                [class.!border-dashed]="isDragOverMap['interview']">

                <div class="flex items-center justify-between mb-4">
                  <h3 class="font-semibold text-gray-900">{{'CANDIDATES.INTERVIEW' | translate}}</h3>
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">{{columnTotalCount['interview']}}
                  </span>
                </div>
                <div class="h-[500px] overflow-y-auto" [class.overflow-y-auto]="interview.length > 0"
                  [class.overflow-y-hidden]="interview.length === 0" (scroll)="onColumnScroll($event, 'interview')">
                  <div cdkDropList id="interview" [cdkDropListData]="interview"
                    [cdkDropListConnectedTo]="['applied', 'screening', 'reference', 'backgroundCheck', 'hired']"
                    (cdkDropListDropped)="drop($event)" (cdkDropListEntered)="onDragEntered('interview')"
                    (cdkDropListExited)="onDragExited('interview')" class="space-y-3 min-h-[500px]">
                    <div *ngFor="let candidate of interview; trackBy: trackByFn" cdkDrag [cdkDragData]="candidate"
                      (cdkDragStarted)="onDragStarted(candidate.id)" (cdkDragEnded)="onDragEnded()"
                      [class.opacity-50]="draggingCandidateId === candidate.id"
                      class="bg-white p-4 rounded-lg shadow-sm border border-gray-200 cursor-move hover:shadow-md transition-shadow">
                      <div class="flex items-center mb-3">
                        <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                          <span class="text-blue-600 font-semibold">{{candidate.firstName.charAt(0)}}</span>
                        </div>
                        <div class="ml-3">
                          <h4 class="font-semibold text-gray-900 text-sm">{{candidate.firstName}}
                            {{candidate.lastName}}
                          </h4>
                        </div>
                      </div>
                      <div class="space-y-2 text-xs text-gray-500">
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-mail w-3 h-3 mr-2">
                            <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                            <path d="m22 7-10 5L2 7"></path>
                          </svg>
                          <span class="truncate">{{candidate.emailAddress}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-phone w-3 h-3 mr-2">
                            <path
                              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                            </path>
                          </svg>
                          <span>{{candidate.phoneNumber}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-calendar w-3 h-3 mr-2">
                            <path d="M8 2v4"></path>
                            <path d="M16 2v4"></path>
                            <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                            <path d="M3 10h18"></path>
                          </svg>
                          <span>{{'CANDIDATES.APPLIED' | translate}} {{candidate.created | date: 'MM/dd/yyyy'}}</span>
                        </div>
                      </div>
                      <div class="mt-3">
                        <div class="flex items-center justify-between mt-2">
                          <div class="flex flex-wrap gap-1">
                            <span 
                              *ngFor="let skill of getCandidateSkills(candidate)"
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                              {{skill}}
                            </span>
                          </div>
                          <div *ngIf="candidate.applicationVideo" class="flex items-center text-blue-600"
                            title="has video application">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-video w-3 h-3">
                              <path d="m22 8-6 4 6 4V8Z"></path>
                              <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-play w-2 h-2 ml-0.5">
                              <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="columnLoading['interview']" class="flex justify-center py-4">
                      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                    </div>
                    <div *ngIf="!columnHasMore['interview'] && interview.length > 0" class="text-center py-4">
                      <p class="text-sm text-gray-500">{{'CANDIDATES.NO_MORE_CANDIDATES' | translate}}</p>
                    </div>
                    <div *ngIf="shouldShowPlaceholder('interview')"
                      class="flex items-center justify-center h-32 text-gray-400">
                      <p class="text-sm">{{'CANDIDATES.DROP_CANDIDATES_HERE' | translate}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Reference Check Column -->
            <div class="flex-1 min-w-[200px]">
              <div class="bg-gray-50 rounded-xl p-4 min-h-[600px] transition-all duration-200"
                [class.!border-2]="isDragOverMap['reference']" [class.!border-blue-300]="isDragOverMap['reference']"
                [class.!border-dashed]="isDragOverMap['reference']">
                <div class="flex items-center justify-between mb-4">
                  <h3 class="font-semibold text-gray-900">{{'CANDIDATES.REFERENCE_CHECK' | translate}}</h3>
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">{{columnTotalCount['reference']}}</span>
                </div>
                <div class="h-[500px] overflow-y-auto" [class.overflow-y-auto]="reference.length > 0"
                  [class.overflow-y-hidden]="reference.length === 0" (scroll)="onColumnScroll($event, 'reference')">
                  <div cdkDropList id="reference" [cdkDropListData]="reference"
                    [cdkDropListConnectedTo]="['applied', 'screening', 'interview', 'backgroundCheck', 'hired']"
                    (cdkDropListDropped)="drop($event)" (cdkDropListEntered)="onDragEntered('reference')"
                    (cdkDropListExited)="onDragExited('reference')" class="space-y-3 min-h-[500px]">
                    <div *ngFor="let candidate of reference; trackBy: trackByFn" cdkDrag [cdkDragData]="candidate"
                      (cdkDragStarted)="onDragStarted(candidate.id)" (cdkDragEnded)="onDragEnded()"
                      [class.opacity-50]="draggingCandidateId === candidate.id"
                      class="bg-white p-4 rounded-lg shadow-sm border border-gray-200 cursor-move hover:shadow-md transition-shadow">
                      <div class="flex items-center mb-3">
                        <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                          <span class="text-blue-600 font-semibold">{{candidate.firstName.charAt(0)}}</span>
                        </div>
                        <div class="ml-3">
                          <h4 class="font-semibold text-gray-900 text-sm">{{candidate.firstName}} {{candidate.lastName}}</h4>
                        </div>
                      </div>
                      <div class="space-y-2 text-xs text-gray-500">
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-mail w-3 h-3 mr-2">
                            <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                            <path d="m22 7-10 5L2 7"></path>
                          </svg>
                          <span class="truncate">{{candidate.emailAddress}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-phone w-3 h-3 mr-2">
                            <path
                              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                            </path>
                          </svg>
                          <span>{{candidate.phoneNumber}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-calendar w-3 h-3 mr-2">
                            <path d="M8 2v4"></path>
                            <path d="M16 2v4"></path>
                            <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                            <path d="M3 10h18"></path>
                          </svg>
                          <span>{{'CANDIDATES.APPLIED' | translate}} {{candidate.created | date: 'MM/dd/yyyy'}}</span>
                        </div>
                      </div>
                      <div class="mt-3">
                        <div class="flex items-center justify-between mt-2">
                          <div class="flex flex-wrap gap-1">
                            <span 
                              *ngFor="let skill of getCandidateSkills(candidate)"
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                              {{skill}}
                            </span>
                          </div>
                          <div *ngIf="candidate.applicationVideo" class="flex items-center text-blue-600"
                            title="has video application">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-video w-3 h-3">
                              <path d="m22 8-6 4 6 4V8Z"></path>
                              <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-play w-2 h-2 ml-0.5">
                              <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="columnLoading['reference']" class="flex justify-center py-4">
                      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                    </div>
                    <div *ngIf="!columnHasMore['reference'] && reference.length > 0" class="text-center py-4">
                      <p class="text-sm text-gray-500">{{'CANDIDATES.NO_MORE_CANDIDATES' | translate}}</p>
                    </div>
                    <div *ngIf="shouldShowPlaceholder('reference')"
                      class="flex items-center justify-center h-32 text-gray-400">
                      <p class="text-sm">{{'CANDIDATES.DROP_CANDIDATES_HERE' | translate}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Background Check Column -->
            <div class="flex-1 min-w-[200px]">
              <div class="bg-gray-50 rounded-xl p-4 min-h-[600px] transition-all duration-200"
                [class.!border-2]="isDragOverMap['backgroundCheck']" [class.!border-blue-300]="isDragOverMap['backgroundCheck']"
                [class.!border-dashed]="isDragOverMap['backgroundCheck']">
                <div class="flex items-center justify-between mb-4">
                  <h3 class="font-semibold text-gray-900">{{'BACKGROUND_CHECK.TITLE' | translate}}</h3>
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">{{columnTotalCount['backgroundCheck']}}</span>
                </div>
                <div class="h-[500px] overflow-y-auto" [class.overflow-y-auto]="backgroundCheck.length > 0"
                  [class.overflow-y-hidden]="backgroundCheck.length === 0" (scroll)="onColumnScroll($event, 'backgroundCheck')">
                  <div cdkDropList id="backgroundCheck" [cdkDropListData]="backgroundCheck"
                    [cdkDropListConnectedTo]="['applied', 'screening', 'interview', 'reference', 'hired']"
                    (cdkDropListDropped)="drop($event)" (cdkDropListEntered)="onDragEntered('backgroundCheck')"
                    (cdkDropListExited)="onDragExited('backgroundCheck')" class="space-y-3 min-h-[500px]">
                    <div *ngFor="let candidate of backgroundCheck; trackBy: trackByFn" cdkDrag [cdkDragData]="candidate"
                      (cdkDragStarted)="onDragStarted(candidate.id)" (cdkDragEnded)="onDragEnded()"
                      [class.opacity-50]="draggingCandidateId === candidate.id"
                      class="bg-white p-4 rounded-lg shadow-sm border border-gray-200 cursor-move hover:shadow-md transition-shadow">
                      <div class="flex items-center mb-3">
                        <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                          <span class="text-blue-600 font-semibold">{{candidate.firstName.charAt(0)}}</span>
                        </div>
                        <div class="ml-3">
                          <h4 class="font-semibold text-gray-900 text-sm">{{candidate.firstName}} {{candidate.lastName}}
                          </h4>
                        </div>
                      </div>
                      <div class="space-y-2 text-xs text-gray-500">
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-mail w-3 h-3 mr-2">
                            <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                            <path d="m22 7-10 5L2 7"></path>
                          </svg>
                          <span class="truncate">{{candidate.emailAddress}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-phone w-3 h-3 mr-2">
                            <path
                              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                            </path>
                          </svg>
                          <span>{{candidate.phoneNumber}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="lucide lucide-calendar w-3 h-3 mr-2">
                            <path d="M8 2v4"></path>
                            <path d="M16 2v4"></path>
                            <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                            <path d="M3 10h18"></path>
                          </svg>
                          <span>{{'CANDIDATES.APPLIED' | translate}} {{candidate.created | date: 'MM/dd/yyyy'}}</span>
                        </div>
                      </div>
                      <div class="mt-3">
                        <div class="flex items-center justify-between mt-2">
                          <div class="flex flex-wrap gap-1">
                            <span 
                              *ngFor="let skill of getCandidateSkills(candidate)"
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                              {{skill}}
                            </span>
                          </div>
                          <div *ngIf="candidate.applicationVideo" class="flex items-center text-blue-600"
                            title="has video application">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-video w-3 h-3">
                              <path d="m22 8-6 4 6 4V8Z"></path>
                              <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-play w-2 h-2 ml-0.5">
                              <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="columnLoading['backgroundCheck']" class="flex justify-center py-4">
                      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                    </div>
                    <div *ngIf="!columnHasMore['backgroundCheck'] && backgroundCheck.length > 0" class="text-center py-4">
                      <p class="text-sm text-gray-500">{{'CANDIDATES.NO_MORE_CANDIDATES' | translate}}</p>
                    </div>
                    <div *ngIf="shouldShowPlaceholder('backgroundCheck')"
                      class="flex items-center justify-center h-32 text-gray-400">
                      <p class="text-sm">{{'CANDIDATES.DROP_CANDIDATES_HERE' | translate}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Hired Column -->
            <div class="flex-1 min-w-[200px]">
              <div class="bg-gray-50 rounded-xl p-4 min-h-[600px] transition-all duration-200"
                [class.!border-2]="isDragOverMap['hired']" [class.!border-blue-300]="isDragOverMap['hired']"
                [class.!border-dashed]="isDragOverMap['hired']">
                <div class="flex items-center justify-between mb-4">
                  <h3 class="font-semibold text-gray-900">{{'SIDEBAR.HIRED' | translate}}</h3>
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">{{columnTotalCount['hired']}}</span>
                </div>
                <div class="h-[500px] overflow-y-auto" [class.overflow-y-auto]="hired.length > 0"
                  [class.overflow-y-hidden]="hired.length === 0" (scroll)="onColumnScroll($event, 'hired')">
                  <div cdkDropList id="hired" [cdkDropListData]="hired"
                    [cdkDropListConnectedTo]="['applied', 'screening', 'interview', 'reference', 'backgroundCheck']"
                    (cdkDropListDropped)="drop($event)" (cdkDropListEntered)="onDragEntered('hired')"
                    (cdkDropListExited)="onDragExited('hired')" class="space-y-3 min-h-[500px]">
                    <div *ngFor="let candidate of hired; trackBy: trackByFn" cdkDrag [cdkDragData]="candidate"
                      (cdkDragStarted)="onDragStarted(candidate.id)" (cdkDragEnded)="onDragEnded()"
                      [class.opacity-50]="draggingCandidateId === candidate.id"
                      class="bg-white p-4 rounded-lg shadow-sm border border-gray-200 cursor-move hover:shadow-md transition-shadow">
                      <div class="flex items-center mb-3">
                        <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                          <span class="text-blue-600 font-semibold">{{candidate.firstName.charAt(0)}}</span>
                        </div>
                        <div class="ml-3">
                          <h4 class="font-semibold text-gray-900 text-sm">{{candidate.firstName}}
                            {{candidate.lastName}}
                          </h4>
                        </div>
                      </div>
                      <div class="space-y-2 text-xs text-gray-500">
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-mail w-3 h-3 mr-2">
                            <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                            <path d="m22 7-10 5L2 7"></path>
                          </svg>
                          <span class="truncate">{{candidate.emailAddress}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-phone w-3 h-3 mr-2">
                            <path
                              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
                            </path>
                          </svg>
                          <span>{{candidate.phoneNumber}}</span>
                        </div>
                        <div class="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-calendar w-3 h-3 mr-2">
                            <path d="M8 2v4"></path>
                            <path d="M16 2v4"></path>
                            <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                            <path d="M3 10h18"></path>
                          </svg>
                          <span>{{'CANDIDATES.APPLIED' | translate}} {{candidate.created | date: 'MM/dd/yyyy'}}</span>
                        </div>
                      </div>
                      <div class="mt-3">
                        <div class="flex items-center justify-between mt-2">
                          <div class="flex flex-wrap gap-1">
                            <span 
                              *ngFor="let skill of getCandidateSkills(candidate)"
                              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                              {{skill}}
                            </span>
                          </div>
                          <div *ngIf="candidate.applicationVideo" class="flex items-center text-blue-600"
                            title="has video application">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-video w-3 h-3">
                              <path d="m22 8-6 4 6 4V8Z"></path>
                              <rect width="14" height="12" x="2" y="6" rx="2" ry="2"></rect>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" class="lucide lucide-play w-2 h-2 ml-0.5">
                              <polygon points="5 3 19 12 5 21 5 3"></polygon>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="columnLoading['hired']" class="flex justify-center py-4">
                      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                    </div>
                    <div *ngIf="!columnHasMore['hired'] && hired.length > 0" class="text-center py-4">
                      <p class="text-sm text-gray-500">{{'CANDIDATES.NO_MORE_CANDIDATES' | translate}}</p>
                    </div>
                    <div *ngIf="shouldShowPlaceholder('hired')"
                      class="flex items-center justify-center h-32 text-gray-400">
                      <p class="text-sm">{{'CANDIDATES.DROP_CANDIDATES_HERE' | translate}}</p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div *ngIf="loading" class="absolute inset-0 bg-white/70 flex items-center justify-center z-50">
            <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
          </div>
        </div>
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h3 class="font-medium text-blue-900 mb-2">{{'CANDIDATES.HOW_TO_USE_SCREENING_BOARD' | translate}}</h3>
          <ul class="text-sm text-blue-800 space-y-1">
            <li>• {{ 'CANDIDATES.TIP_DRAG_CARDS' | translate }}</li>
            <li>• {{ 'CANDIDATES.TIP_VISUALIZE_PIPELINE' | translate }}</li>
            <li>• {{ 'CANDIDATES.TIP_CLICK_CANDIDATES' | translate }}</li>
          </ul>
        </div>
      </main>
    </div>
  </div>
</div>